'use client';

import { LinguiProvider } from '@/i18n/LinguiProvider';
import type { Locale } from '@/i18n/i18n-config';
import { ThemeProvider } from '@/theme/ThemeProvider';
import type { Messages } from '@lingui/core';
import type { MantineColorScheme } from '@mantine/core';
import type { PropsWithChildren } from 'react';
import { AuthProvider } from './AuthProvider';
import { ChatProvider } from './ChatProvider';
import { ModalActionProvider } from './ModalActionProvider';
export type ProvidersProps = PropsWithChildren<{
  colorScheme: MantineColorScheme;
  locale: Locale;
  messages: Messages;
}>;
export const Providers: React.FC<ProvidersProps> = ({
  children,
  locale,
  messages,
  colorScheme
}) => {
  return <ThemeProvider colorScheme={colorScheme}>
      <LinguiProvider locale={locale} messages={messages}>
        <AuthProvider>
          <ModalActionProvider>
            <ChatProvider>{children}</ChatProvider>
          </ModalActionProvider>
        </AuthProvider>
      </LinguiProvider>
    </ThemeProvider>;
};